import { render, staticRenderFns } from "./DeletePicklPopup.vue?vue&type=template&id=67032e82&scoped=true&"
import script from "./DeletePicklPopup.vue?vue&type=script&lang=ts&"
export * from "./DeletePicklPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeletePicklPopup.vue?vue&type=style&index=0&id=67032e82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67032e82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67032e82')) {
      api.createRecord('67032e82', component.options)
    } else {
      api.reload('67032e82', component.options)
    }
    module.hot.accept("./DeletePicklPopup.vue?vue&type=template&id=67032e82&scoped=true&", function () {
      api.rerender('67032e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SAdmin/DeletePicklPopup.vue"
export default component.exports